import { Component, Injector, OnInit } from '@angular/core';
import { GeozoneViewModel } from "../Model/GeozoneViewModel";
import { ZoneService } from "../../../../services/zones.service";
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { IManagableObject } from '../../IManagableObject';
import { ContainersService } from 'app/services/containers.service';
import { ContainerViewModel } from '../../ContainerViewModel';
import { forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-create-geozone-dialog',
  templateUrl: './create-geozone-dialog.component.html',
  styleUrls: ['./create-geozone-dialog.component.css'],
  standalone: false
})
export class CreateGeozoneDialogComponent extends DialogBaseComponent<GeozoneViewModel> implements OnInit {

  private zonesService: ZoneService;
  private containersService: ContainersService;

  public groups: IManagableObject[] = [];
  public containers: ContainerViewModel[] = [];
  public isLoading: boolean = true;
  constructor(protected injector: Injector) {
    super(injector);
    this.zonesService = injector.get(ZoneService);
    this.containersService = injector.get(ContainersService);
  }

  ngOnInit(): void {
    this.isLoading = true;
    forkJoin({
      groups: this.zonesService.GetGroups(),
      containers: this.getContainersRequest()
    }).subscribe(result => {
      this.groups = result.groups;
      this.applyContainers(result.containers);
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
    });
  }

  submit() {
    if (!this.model.ContainerId) {
      this.toastr.error(this.translate.instant("Container is required"));
      return;
    }

    this.zonesService.CreateZone(this.model)
      .subscribe((res) => {
        this.syncService.NotifyEntityChanged("Geozone", this.model.Id);
        super.submit();
      });
  }

  private getContainersRequest() {
    const companyId = this.usersService.getCurrentUser()?.CompanyId ?? 0;
    if (!companyId) {
      return of([] as ContainerViewModel[]);
    }

    return this.containersService.GetContainers();
  }

  private applyContainers(containers: ContainerViewModel[] | null | undefined) {
    this.containers = containers ?? [];
    if (!this.model.ContainerId || !this.containers.some(x => x.Id === this.model.ContainerId))
      this.model.ContainerId = this.containers[0]?.Id;
  }
}
